import { useSelector } from 'react-redux';
import { addFaqData } from '../Redux/actions';
import { hasFaqSelector } from '../Redux/selectors';
import { WithFetchJsonContent } from './WithFetchJsonContent';

export const WithFaqData = ({ children }) => {
  const hasFaq = useSelector(hasFaqSelector);

  return (
    <WithFetchJsonContent reduxInStore={hasFaq} addToReduxFunction={addFaqData} jsonLocation="content/faq">
      {children}
    </WithFetchJsonContent>
  );
}
